import React from "react";

import "./styles.scss";

export const Shimmer = (props) => {
  const colorHex = props.colorHex ? props.colorHex : "#eff1f3";
  const secondaryColorHex = props.secondaryColorHex
    ? props.secondaryColorHex
    : "#e2e2e2";

  let shimmerStyles = {
    ...props.shimmerStyles,
    background:
      "linear-gradient(to right, " +
      colorHex +
      " 4%, " +
      secondaryColorHex +
      " 25%, " +
      colorHex +
      " 36%)",
  };

  if (props.disableAnimation) {
    shimmerStyles = {
      ...props.shimmerStyles,
      backgroundColor:  "#eff1f3"
    };
    
  }

  return <div style={shimmerStyles} className="ps-shimmer--animate"></div>;
};
